// @ts-nocheck
import axios from "@/helpers/interceptors";
import {downloadBlob, getAccessToken, getFileNameFromHeader} from "@/helpers/utils";
import { B2bPortalRight } from "@/enums/B2bPortalRight";
import { vuexHasAnyPortalRight, vuexHasPortalRight } from "@/helpers/vuexPortalPermissions";
const state = {
  transactionsHasComplianceRequest: false,
};
const mutations = {
  SET_TRANSACTIONS_HAS_COMPLIANCE_REQUEST(state, payload) {
    state.transactionsHasComplianceRequest = payload;
  },
};
const actions = {

  /**
   * @name fetchTransactionsList
   * @description get list of transactions
   */

  async fetchTransactionsList({ rootState }, {
    from, to, offset, limit, accountNumber, IncludeOrderStatusStorno, clientId = null
  }) {
    try {
      if (!vuexHasPortalRight(rootState, B2bPortalRight.AccountTransactionView)) {
        return [];
      }
      const body = {
        to,
        from,
      };
      if (accountNumber) {
        body.accountNumber = accountNumber;
        body.IncludeOrderStatusStorno = IncludeOrderStatusStorno;
      }
      if (clientId) {
        body.clientId = clientId;
      }

			//Check if token not Exist don't call axios
			const accessToken = await getAccessToken();
			if(!accessToken) return []
			//end Check if token not Exist don't call axios

      const { status, data } = await axios.post(`/api/transactions/list/${offset}/${limit}`, body);
      console.log(data, "data");
      if (status === 200) {
        return data.transactions || [];
      }
      return [];
    } catch (e) {
      console.log(e);
      return [];
    }
  },

  /**
   * @name fetchTransactionsList
   * @description get list of transactions
   */

  async fetchTransactionsListWithComplianceRequest({ commit, rootState }, {
    offset, limit
  }) {
    try {
      if (!vuexHasPortalRight(rootState, B2bPortalRight.AccountTransactionView)) {
        return [];
      }
      const currentDate = new Date(); // Get the current date
      const currentYear = currentDate.getFullYear(); // Get the current year
      const tenYearsAgo = new Date(currentYear - 10, currentDate.getMonth(), currentDate.getDate());
      const body = {
        to: currentDate,
        from: tenYearsAgo,
        needRequiredDocumentsOnly: true
      };

			//Check if token not Exist don't call axios
			const accessToken = await getAccessToken();
			if(!accessToken) return []
			//end Check if token not Exist don't call axios

      const { status, data } = await axios.post(`/api/transactions/list/${offset}/${limit}`, body);

      if (status === 200) {
        if (limit === 1) {
          commit("SET_TRANSACTIONS_HAS_COMPLIANCE_REQUEST", Boolean(data?.transactions?.length));
        }
        return data.transactions || [];
      }
      return [];
    } catch (e) {
      console.log(e);
      return [];
    }
  },

  /**
   * @name fetchCardsTransactionsList
   * @description get list of all cards transactions
   */

  async fetchCardsTransactionsList({ rootState }, { offset, limit }) {
    try {
      if (!vuexHasPortalRight(rootState, B2bPortalRight.CardTransactionView)) {
        return [];
      }
      const { status, data } = await axios.get(`/api/cards/get-transactions/${offset}/${limit}`, {});
      console.log(data, "data");
      if (status === 200) {
        return data.transactions || [];
      }
      return [];
    } catch (e) {
      console.log(e);
      return [];
    }
  },

  /**
   * @name fetchCardTransactionsList by public Token
   * @description get list of all card transactions
   */

  async fetchCardTransactionsList({ rootState }, {
    offset, limit, publicToken
  }) {
    try {
      if (!vuexHasPortalRight(rootState, B2bPortalRight.CardTransactionView)) {
        return [];
      }
      const { status, data } = await axios.get(`/api/cards/get-transactions/${publicToken}/${offset}/${limit}`, {});
      console.log(data, "data");
      if (status === 200) {
        return data.transactions || [];
      }
      return [];
    } catch (e) {
      console.log(e);
      return [];
    }
  },

  /**
   * @name fetchCardsStatusesList
   * @description get list of all cards statuses changes
   */
  // eslint-disable-next-line
  async fetchCardsStatusesList({ rootState }) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.CardView)) return;
    try {
      const { status, data } = await axios.get("/api/cards/get-status-history", {});
      console.log(data, "data");
      if (status === 200) {
        return data;
      }
    } catch (e) {
      console.log(e);
    }
  },

  /**
   * @name fetchCardsStatusesList by publicToken
   * @description get list of all card statuses changes
   */

  async fetchCardStatusesList({ rootState }, { publicToken }) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.CardView)) return;
    try {
      const { status, data } = await axios.get(`/api/cards/get-status-history/${publicToken}`, {});
      console.log(data, "data");
      if (status === 200) {
        return data;
      }
    } catch (e) {
      console.log(e);
    }
  },

  /**
   * @name fetchTransaction
   * @description get transaction by reference number
   */

  // eslint-disable-next-line consistent-return
  async fetchTransaction({ rootState }, payload = { referenceNumber: null, clientId: null }) {
    try {
      if (!vuexHasPortalRight(rootState, B2bPortalRight.PaymentView)) {
        return [];
      }
     
      // Ensure payload is an object and extract values safely
      const payloadObj = payload || {};
      const referenceNumber = payloadObj.referenceNumber;
      const clientIdParam = payloadObj.clientId;
      
      const params = {};
      // Only add clientId to params if it's defined (not undefined and not null)
      if (clientIdParam !== undefined && clientIdParam !== null) {
        params.clientId = clientIdParam;
      }
      const { status, data } = await axios.get(`/api/transactions/${referenceNumber}`, { params });
      if (status === 200 && data.transaction) {
        return data.transaction;
      }
    } catch (e) {
      console.log(e);
    }
  },

  /**
   * @name exportAccountsStatement
   * @description get transactions by all account in pdf format
   */

  async exportAccountsStatement({ rootState }, {
    from, to, accountNumber , mimeType, includeOrderStatusStorno, clientId = undefined
  }) {
    if (!vuexHasAnyPortalRight(rootState, [
      B2bPortalRight.AccountTransactionReport,
      B2bPortalRight.ExtendedAccountTransactionReport,
    ])) {
      return;
    }
    try {
      const { data, status, headers } = await axios.post(
        `/api/accounts/statement/${accountNumber || ""}`,
        {
          from,
          to,
          mimeType,
          includeOrderStatusStorno,
          clientId: clientId || null
        },
        { responseType: "blob" }
      );
      if (status === 200) {
        await downloadBlob(data, getFileNameFromHeader(headers["content-disposition"]));
      }
    } catch (e) {
      console.log(e);
    }
  },

  /**
   * @name fetchTransactionCheck
   * @description get transaction details in pdf format
   */

  async fetchTransactionCheck({ rootState },  payload = { referenceNumber: null, merchantId: null }) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.PaymentReport)) return;
    try {
      const payloadObj = payload || {};
      const referenceNumber = payloadObj.referenceNumber;
      const merchantId = payloadObj.merchantId;
      const params = {};
      // Only add clientId to params if it's defined (not undefined and not null)
      if (merchantId !== undefined && merchantId !== null) {
        params.merchantId = merchantId;
      }

      const {
        status,
        data,
        headers
      } = await axios.get(`/api/transactions/check/${referenceNumber}`, { params, responseType: "blob" });
      if (status === 200) {
        await downloadBlob(data, getFileNameFromHeader(headers["content-disposition"]));
      }
    } catch (e) {
      console.log(e);
    }
  },

  /**
   * @name exportCardsStatement
   * @description get transactions by all cards in pdf/csv format
   */

  async exportCardsStatement({ rootState }, {
    publicToken, dateFrom, dateTo, exportFileExtension , type
  }) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.CardTransactionReport)) return;
    try {
      const mimeType = exportFileExtension === "pdf" ? "application/pdf" : "text/csv";
      const { data, status, headers } = await axios.post(
        "/api/cards/statement",
        {
          publicToken,
          dateFrom,
          dateTo,
          mimeType,
          type,
        },
        { responseType: "blob" }
      );
      if (status === 200) {
        await downloadBlob(data, getFileNameFromHeader(headers["content-disposition"]));
      }
    } catch (e) {
      console.log(e);
    }
  }

};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
